module.exports = __webpack_public_path__ + "img/1391782679.84611d50.jpg";